<script setup>
import { BaseCard, BaseIcon } from '@edsights/ui-core';
import { replaceBindings } from '@/lib/string-helpers';

const props = defineProps({
    bindings: {
        type: Object,
        required: true
    },
    template: {
        type: Object,
        required: true
    }
});

const formatDescription = (description) => {
    return replaceBindings(description, props.bindings);
};
</script>

<template>
    <BaseCard class="template-card">
        <template #content>
            <div class="template-card__content">
                <BaseIcon icon="book" />
                <h3 class="template-card-title">{{ template.name }}</h3>
                <p>{{ formatDescription(template.touchpointDescription) }}</p>
            </div>
        </template>
    </BaseCard>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.template-card {
    display: flex;

    &__content {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        margin: 1rem;
    }

    :deep(.pi) {
        font-size: 2rem;
        color: $edsights-blue;
    }

    .template-card-title {
        font-size: 14px;
    }
}
</style>
